import { createActions } from 'redux-actions'
import { identity } from 'lodash/fp'

export const appConfigActions = createActions({
  UPDATE_API_VERSION: identity,
  CHECK_API_VERSION: identity,
})
